// Complete Compliance Framework Data
// Generated from compliance_framework_mapping.md
// Total: 200+ controls across 18 frameworks

// OMB M-15-13 (HTTPS-Only Standard) - 9 controls
export const OMB_M_15_13_CONTROLS = [
  {
    id: "OMB-M-15-13-01",
    requirement: "HTTPS Enforcement",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "HTTP to HTTPS redirect validation",
    passCriteria: "PASS: 301/302 redirect to HTTPS",
    keyFields: ["Redirects", "Valid_HTTPS"]
  },
  {
    id: "OMB-M-15-13-02",
    requirement: "HTTPS Availability",
    scan: "pshtt, 200scanner",
    collection: "pshtt_scan_collection, 200scanner_scan_collection",
    technicalTest: "HTTPS connection establishment",
    passCriteria: "PASS: Successful HTTPS connection",
    keyFields: ["HTTPS_Live", "Live", "status_code"]
  },
  {
    id: "OMB-M-15-13-03",
    requirement: "Certificate Validation",
    scan: "pshtt, sslyze",
    collection: "pshtt_scan_collection, sslyze_scan_collection",
    technicalTest: "SSL certificate chain validation",
    passCriteria: "PASS: Valid, non-expired certificate from trusted CA",
    keyFields: ["Valid_HTTPS", "certificate_info", "certificate_matches_hostname"]
  },
  {
    id: "OMB-M-15-13-04",
    requirement: "Strong Encryption",
    scan: "sslyze",
    collection: "sslyze_scan_collection",
    technicalTest: "Cipher suite and protocol analysis",
    passCriteria: "PASS: TLS 1.2+, strong cipher suites only",
    keyFields: ["ssl_2_0_cipher_suites", "tls_1_0_cipher_suites", "tls_1_2_cipher_suites", "tls_1_3_cipher_suites"]
  },
  {
    id: "OMB-M-15-13-05",
    requirement: "HSTS Implementation",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "Strict-Transport-Security header check",
    passCriteria: "PASS: HSTS header with max-age ≥ 31536000",
    keyFields: ["HSTS", "HSTS_Max_Age", "HSTS_Entire_Domain"]
  },
  {
    id: "OMB-M-15-13-06",
    requirement: "HSTS Preloading",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "Chrome HSTS preload list inclusion",
    passCriteria: "PASS: Domain included in preload list",
    keyFields: ["HSTS_Preloaded"]
  },
  {
    id: "OMB-M-15-13-07",
    requirement: "Mixed Content Prevention",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "Mixed HTTP/HTTPS content detection",
    passCriteria: "PASS: No mixed content warnings",
    keyFields: ["HTTPS_Bad_Chain", "HTTPS_Bad_Hostname"]
  },
  {
    id: "OMB-M-15-13-08",
    requirement: "Perfect Forward Secrecy",
    scan: "sslyze",
    collection: "sslyze_scan_collection",
    technicalTest: "Ephemeral key exchange validation",
    passCriteria: "PASS: All cipher suites support PFS",
    keyFields: ["ephemeral_key_reuse", "cipher_suite_supported"]
  },
  {
    id: "OMB-M-15-13-09",
    requirement: "Certificate Transparency",
    scan: "sslyze",
    collection: "sslyze_scan_collection",
    technicalTest: "CT log submission verification",
    passCriteria: "PASS: Certificate logged in CT logs",
    keyFields: ["certificate_transparency"]
  }
];

// BOD 18-01 (Enhance Email and Web Security) - 7 controls
export const BOD_18_01_CONTROLS = [
  {
    id: "BOD-18-01-01",
    requirement: "DMARC Policy Implementation",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "DNS DMARC record validation",
    passCriteria: "PASS: Valid DMARC with p=quarantine or p=reject",
    keyFields: ["Valid_DMARC", "DMARC_Policy", "DMARC_Policy_Percentage"]
  },
  {
    id: "BOD-18-01-02",
    requirement: "SPF Record Configuration",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "SPF record syntax and policy validation",
    passCriteria: "PASS: Valid SPF record ending with -all or ~all",
    keyFields: ["Valid_SPF", "SPF_Record"]
  },
  {
    id: "BOD-18-01-03",
    requirement: "DKIM Implementation",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "DKIM signature validation capability",
    passCriteria: "PASS: Valid DKIM selector and public key",
    keyFields: ["DKIM_Record", "Valid_DKIM"]
  },
  {
    id: "BOD-18-01-04",
    requirement: "Domain-based Security",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "Email authentication alignment",
    passCriteria: "PASS: DMARC, SPF, DKIM all properly aligned",
    keyFields: ["Domain_Supports_DMARC", "Domain_Supports_SPF"]
  },
  {
    id: "BOD-18-01-05",
    requirement: "HTTPS Enforcement",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "Same as OMB M-15-13 requirements",
    passCriteria: "PASS: Full HTTPS implementation",
    keyFields: ["Valid_HTTPS", "Redirects", "HSTS"]
  },
  {
    id: "BOD-18-01-06",
    requirement: "Content Security Policy",
    scan: "csp",
    collection: "csp_scan_collection",
    technicalTest: "CSP header analysis and validation",
    passCriteria: "PASS: Restrictive CSP with no unsafe directives",
    keyFields: ["header_present", "policy_directives", "unsafe_inline", "unsafe_eval"]
  },
  {
    id: "BOD-18-01-07",
    requirement: "Subdomain Coverage",
    scan: "trustymail, pshtt",
    collection: "Multiple collections",
    technicalTest: "Subdomain security validation",
    passCriteria: "PASS: All subdomains covered by security policies",
    keyFields: ["HSTS_Entire_Domain", "subdomain_coverage"]
  }
];

// Web Application Security Configuration - 10 controls
export const WEB_APP_SECURITY_CONTROLS = [
  {
    id: "WEB-SEC-01",
    requirement: "SQL Injection Prevention",
    scan: "zaproxy_scan, wapiti_scan, nuclei_scan",
    collection: "zaproxy_scan_collection, zap_scan_alerts_collection, wapiti_scan_collection, nuclei_scan_collection",
    technicalTest: "Input validation and parameterized query testing",
    passCriteria: "PASS: No SQL injection vulnerabilities detected",
    keyFields: ["sql_injection_alerts", "risk_level", "confidence", "cwe_id"]
  },
  {
    id: "WEB-SEC-02",
    requirement: "Cross-Site Scripting (XSS) Prevention",
    scan: "zaproxy_scan, wapiti_scan, nuclei_scan",
    collection: "Multiple alert collections",
    technicalTest: "Reflected, stored, and DOM-based XSS testing",
    passCriteria: "PASS: No XSS vulnerabilities found",
    keyFields: ["xss_alerts", "xss_reflected", "xss_stored", "severity"]
  },
  {
    id: "WEB-SEC-03",
    requirement: "Security Headers Implementation",
    scan: "nikto_scan, nuclei_scan, csp",
    collection: "nikto_scan_collection, nuclei_scan_collection, csp_scan_collection",
    technicalTest: "HTTP security header validation",
    passCriteria: "PASS: All required security headers present",
    keyFields: ["security_headers", "x_frame_options", "x_content_type_options", "x_xss_protection"]
  },
  {
    id: "WEB-SEC-04",
    requirement: "Directory Traversal Prevention",
    scan: "nikto_scan, wapiti_scan",
    collection: "nikto_scan_collection, wapiti_scan_collection",
    technicalTest: "Path traversal vulnerability testing",
    passCriteria: "PASS: No directory traversal vulnerabilities",
    keyFields: ["traversal_issues", "path_disclosure", "directory_listing"]
  },
  {
    id: "WEB-SEC-05",
    requirement: "Insecure Direct Object References",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Authorization and access control testing",
    passCriteria: "PASS: No IDOR vulnerabilities detected",
    keyFields: ["access_control_alerts", "authorization_bypass", "privilege_escalation"]
  },
  {
    id: "WEB-SEC-06",
    requirement: "Command Injection Prevention",
    scan: "wapiti_scan, nuclei_scan",
    collection: "wapiti_scan_collection, nuclei_scan_collection",
    technicalTest: "Command execution vulnerability testing",
    passCriteria: "PASS: No command injection vulnerabilities",
    keyFields: ["command_injection", "code_execution", "remote_command_execution"]
  },
  {
    id: "WEB-SEC-07",
    requirement: "File Upload Security",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "File upload mechanism security testing",
    passCriteria: "PASS: Secure file upload validation",
    keyFields: ["file_upload_vulnerabilities", "unrestricted_file_upload"]
  },
  {
    id: "WEB-SEC-08",
    requirement: "Session Management",
    scan: "zaproxy_scan, nikto_scan",
    collection: "zaproxy_scan_collection, nikto_scan_collection",
    technicalTest: "Session security and cookie validation",
    passCriteria: "PASS: Secure session implementation",
    keyFields: ["session_management", "cookie_security", "session_fixation"]
  },
  {
    id: "WEB-SEC-09",
    requirement: "Information Disclosure Prevention",
    scan: "nikto_scan, nuclei_scan",
    collection: "nikto_scan_collection, nuclei_scan_collection",
    technicalTest: "Sensitive information exposure testing",
    passCriteria: "PASS: No sensitive information disclosed",
    keyFields: ["information_disclosure", "error_messages", "debug_information"]
  },
  {
    id: "WEB-SEC-10",
    requirement: "CSRF Protection",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Cross-site request forgery testing",
    passCriteria: "PASS: CSRF tokens implemented correctly",
    keyFields: ["csrf_vulnerabilities", "anti_csrf_tokens"]
  }
];

// TIC 3.0 (Trusted Internet Connections) - 6 controls
export const TIC_3_0_CONTROLS = [
  {
    id: "TIC-3.0-01",
    requirement: "External Connection Inventory",
    scan: "outbound_link_scan",
    collection: "outbound_link_scan_collection",
    technicalTest: "External link and connection enumeration",
    passCriteria: "PASS: All external connections documented",
    keyFields: ["external_domains", "connection_count", "link_destinations"]
  },
  {
    id: "TIC-3.0-02",
    requirement: "Third-Party Service Assessment",
    scan: "third_parties",
    collection: "third_parties_scan_collection",
    technicalTest: "Third-party service and tracker identification",
    passCriteria: "PASS: All third-party services authorized",
    keyFields: ["detected_services", "privacy_concerns", "tracking_services"]
  },
  {
    id: "TIC-3.0-03",
    requirement: "Technology Stack Visibility",
    scan: "wappybird_scan",
    collection: "wappybird_scan_collection",
    technicalTest: "Web technology and framework detection",
    passCriteria: "PASS: Complete technology inventory maintained",
    keyFields: ["technologies_detected", "versions", "frameworks", "cms_platforms"]
  },
  {
    id: "TIC-3.0-04",
    requirement: "Encrypted Communications Enforcement",
    scan: "pshtt, sslyze",
    collection: "pshtt_scan_collection, sslyze_scan_collection",
    technicalTest: "End-to-end encryption validation",
    passCriteria: "PASS: All communications encrypted",
    keyFields: ["Valid_HTTPS", "HTTPS_Live", "cipher_suites"]
  },
  {
    id: "TIC-3.0-05",
    requirement: "DNS Security Validation",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "DNS security configuration assessment",
    passCriteria: "PASS: Secure DNS settings implemented",
    keyFields: ["mx_records", "domain_security", "dns_security"]
  },
  {
    id: "TIC-3.0-06",
    requirement: "Content Delivery Network Assessment",
    scan: "third_parties, outbound_link_scan",
    collection: "Multiple collections",
    technicalTest: "CDN and external resource validation",
    passCriteria: "PASS: Approved CDNs and resources only",
    keyFields: ["cdn_usage", "external_resources", "resource_domains"]
  }
];

// Section 508 Compliance - 16 controls (§1194.22(a) through §1194.22(p))
export const SECTION_508_CONTROLS = [
  {
    id: "SECTION-508-A",
    requirement: "§1194.22(a) - Alternative Text for Images",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Image alt attribute validation",
    passCriteria: "PASS: All images have descriptive alt text",
    keyFields: ["missing_alt_text", "image_accessibility", "alt_text_quality"]
  },
  {
    id: "SECTION-508-B",
    requirement: "§1194.22(b) - Multimedia Alternatives",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Video/audio accessibility features",
    passCriteria: "PASS: Captions, transcripts, or audio descriptions",
    keyFields: ["multimedia_accessibility", "caption_availability"]
  },
  {
    id: "SECTION-508-C",
    requirement: "§1194.22(c) - Color Independence",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Color contrast and color-only information",
    passCriteria: "PASS: 4.5:1 contrast ratio, no color-only information",
    keyFields: ["color_contrast_failures", "color_only_information"]
  },
  {
    id: "SECTION-508-D",
    requirement: "§1194.22(d) - Document Structure",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Heading hierarchy and document organization",
    passCriteria: "PASS: Logical heading structure, proper markup",
    keyFields: ["heading_structure", "document_structure", "semantic_markup"]
  },
  {
    id: "SECTION-508-E",
    requirement: "§1194.22(e) - Data Table Headers",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Table header association validation",
    passCriteria: "PASS: All data tables have proper headers",
    keyFields: ["table_accessibility", "table_headers", "th_scope_attributes"]
  },
  {
    id: "SECTION-508-F",
    requirement: "§1194.22(f) - Row/Column Headers",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Complex table header relationships",
    passCriteria: "PASS: Headers properly associated with data cells",
    keyFields: ["table_header_relationships", "complex_table_structure"]
  },
  {
    id: "SECTION-508-G",
    requirement: "§1194.22(g) - Form Element Association",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Form label and control association",
    passCriteria: "PASS: All form elements properly labeled",
    keyFields: ["form_label_issues", "form_accessibility", "label_associations"]
  },
  {
    id: "SECTION-508-H",
    requirement: "§1194.22(h) - Moving Content Control",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Animation and auto-updating content",
    passCriteria: "PASS: User control over moving content",
    keyFields: ["animation_controls", "auto_refresh_content"]
  },
  {
    id: "SECTION-508-I",
    requirement: "§1194.22(i) - Frame Identification",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Frame and iframe title validation",
    passCriteria: "PASS: All frames have descriptive titles",
    keyFields: ["frame_title_issues", "iframe_accessibility"]
  },
  {
    id: "SECTION-508-J",
    requirement: "§1194.22(j) - Screen Flicker Prevention",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Flashing content detection",
    passCriteria: "PASS: No content flashes >3Hz or below safe thresholds",
    keyFields: ["flicker_detection", "flashing_content"]
  },
  {
    id: "SECTION-508-K",
    requirement: "§1194.22(k) - Text-Only Alternative",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Text equivalent page availability",
    passCriteria: "PASS: Text-only version available when needed",
    keyFields: ["text_alternatives", "text_only_version"]
  },
  {
    id: "SECTION-508-L",
    requirement: "§1194.22(l) - Skip Navigation Links",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Skip link implementation and functionality",
    passCriteria: "PASS: Skip links present and functional",
    keyFields: ["skip_link_issues", "navigation_bypass"]
  },
  {
    id: "SECTION-508-M",
    requirement: "§1194.22(m) - Timed Response Extensions",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Time limit control validation",
    passCriteria: "PASS: Users can extend or disable time limits",
    keyFields: ["time_limit_controls", "session_timeout"]
  },
  {
    id: "SECTION-508-N",
    requirement: "§1194.22(n) - Form Completion Assistance",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Form error handling and guidance",
    passCriteria: "PASS: Clear error messages and completion help",
    keyFields: ["form_error_handling", "completion_assistance"]
  },
  {
    id: "SECTION-508-O",
    requirement: "§1194.22(o) - Method for Skipping Repetitive Links",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Alternative navigation method validation",
    passCriteria: "PASS: Method exists to skip repetitive navigation",
    keyFields: ["repetitive_link_bypass", "navigation_alternatives"]
  },
  {
    id: "SECTION-508-P",
    requirement: "§1194.22(p) - Explicit Focus Indication",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Focus indicator visibility testing",
    passCriteria: "PASS: Clear focus indicators on all interactive elements",
    keyFields: ["focus_indicators", "keyboard_navigation", "focus_management"]
  }
];

// WCAG 2.1 AA Compliance - 22 success criteria
export const WCAG_2_1_AA_CONTROLS = [
  {
    id: "WCAG-1.1.1",
    requirement: "1.1.1 - Non-text Content",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Alternative text validation",
    passCriteria: "PASS: All non-text content has text alternatives",
    keyFields: ["missing_alt_text", "alternative_text_quality"]
  },
  {
    id: "WCAG-1.3.1",
    requirement: "1.3.1 - Info and Relationships",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Semantic structure validation",
    passCriteria: "PASS: Information and relationships conveyed through markup",
    keyFields: ["semantic_issues", "structural_markup"]
  },
  {
    id: "WCAG-1.3.2",
    requirement: "1.3.2 - Meaningful Sequence",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Content reading order validation",
    passCriteria: "PASS: Content has meaningful reading sequence",
    keyFields: ["reading_order", "content_sequence"]
  },
  {
    id: "WCAG-1.4.3",
    requirement: "1.4.3 - Contrast (Minimum)",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Color contrast ratio measurement",
    passCriteria: "PASS: 4.5:1 normal text, 3:1 large text",
    keyFields: ["color_contrast_failures", "contrast_ratios"]
  },
  {
    id: "WCAG-1.4.4",
    requirement: "1.4.4 - Resize Text",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Text scaling validation",
    passCriteria: "PASS: Text can be resized to 200% without loss",
    keyFields: ["text_resize_issues", "responsive_text"]
  },
  {
    id: "WCAG-1.4.5",
    requirement: "1.4.5 - Images of Text",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Text image usage validation",
    passCriteria: "PASS: Images of text only when necessary",
    keyFields: ["images_of_text", "text_alternatives"]
  },
  {
    id: "WCAG-2.1.1",
    requirement: "2.1.1 - Keyboard Navigation",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Keyboard accessibility testing",
    passCriteria: "PASS: All functionality available via keyboard",
    keyFields: ["keyboard_navigation_issues", "keyboard_traps"]
  },
  {
    id: "WCAG-2.1.2",
    requirement: "2.1.2 - No Keyboard Trap",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Keyboard trap detection",
    passCriteria: "PASS: No keyboard focus traps",
    keyFields: ["keyboard_traps", "focus_management"]
  },
  {
    id: "WCAG-2.4.1",
    requirement: "2.4.1 - Bypass Blocks",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Skip link functionality",
    passCriteria: "PASS: Mechanism to bypass repetitive content",
    keyFields: ["skip_link_issues", "bypass_mechanisms"]
  },
  {
    id: "WCAG-2.4.2",
    requirement: "2.4.2 - Page Titles",
    scan: "a11y, seo",
    collection: "a11y_scan_collection, seo_scan_collection",
    technicalTest: "Page title validation",
    passCriteria: "PASS: Descriptive and unique page titles",
    keyFields: ["page_title_issues", "title_quality"]
  },
  {
    id: "WCAG-2.4.3",
    requirement: "2.4.3 - Focus Order",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Tab order validation",
    passCriteria: "PASS: Logical focus order",
    keyFields: ["focus_order_issues", "tab_sequence"]
  },
  {
    id: "WCAG-2.4.4",
    requirement: "2.4.4 - Link Purpose",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Link context validation",
    passCriteria: "PASS: Link purpose clear from context",
    keyFields: ["link_purpose_issues", "link_accessibility"]
  },
  {
    id: "WCAG-2.4.6",
    requirement: "2.4.6 - Headings and Labels",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Heading and label descriptiveness",
    passCriteria: "PASS: Descriptive headings and labels",
    keyFields: ["heading_structure", "form_label_issues"]
  },
  {
    id: "WCAG-2.4.7",
    requirement: "2.4.7 - Focus Visible",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Focus indicator visibility",
    passCriteria: "PASS: Visible focus indicators",
    keyFields: ["focus_indicators", "focus_visibility"]
  },
  {
    id: "WCAG-3.1.1",
    requirement: "3.1.1 - Language of Page",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Page language identification",
    passCriteria: "PASS: Primary language identified",
    keyFields: ["language_issues", "lang_attribute"]
  },
  {
    id: "WCAG-3.1.2",
    requirement: "3.1.2 - Language of Parts",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Language change identification",
    passCriteria: "PASS: Language changes identified",
    keyFields: ["language_changes", "multilingual_content"]
  },
  {
    id: "WCAG-3.2.1",
    requirement: "3.2.1 - On Focus",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Focus change behavior",
    passCriteria: "PASS: No context changes on focus",
    keyFields: ["focus_context_changes"]
  },
  {
    id: "WCAG-3.2.2",
    requirement: "3.2.2 - On Input",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Input change behavior",
    passCriteria: "PASS: No unexpected context changes",
    keyFields: ["input_context_changes"]
  },
  {
    id: "WCAG-3.3.1",
    requirement: "3.3.1 - Error Identification",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Form error identification",
    passCriteria: "PASS: Errors clearly identified",
    keyFields: ["form_error_handling", "error_identification"]
  },
  {
    id: "WCAG-3.3.2",
    requirement: "3.3.2 - Labels or Instructions",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Form instruction validation",
    passCriteria: "PASS: Labels or instructions provided",
    keyFields: ["form_label_issues", "input_instructions"]
  },
  {
    id: "WCAG-4.1.1",
    requirement: "4.1.1 - Parsing",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "HTML markup validation",
    passCriteria: "PASS: Valid HTML markup",
    keyFields: ["markup_validation", "parsing_errors"]
  },
  {
    id: "WCAG-4.1.2",
    requirement: "4.1.2 - Name, Role, Value",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "ARIA and semantic validation",
    passCriteria: "PASS: Proper name, role, value for UI components",
    keyFields: ["aria_issues", "semantic_issues"]
  }
];

// 21st Century IDEA Act - 8 requirements
export const CENTURY_21_IDEA_CONTROLS = [
  {
    id: "IDEA-01",
    requirement: "Mobile-Friendly Design",
    scan: "lighthouse_scan",
    collection: "lighthouse_scan_collection",
    technicalTest: "Mobile usability and responsiveness",
    passCriteria: "PASS: Mobile-friendly score ≥ 90",
    keyFields: ["mobile_friendly_score", "mobile_usability", "responsive_design"]
  },
  {
    id: "IDEA-02",
    requirement: "Accelerated Mobile Pages",
    scan: "lighthouse_scan",
    collection: "lighthouse_scan_collection",
    technicalTest: "AMP implementation validation",
    passCriteria: "PASS: AMP properly implemented where applicable",
    keyFields: ["amp_validation", "mobile_performance"]
  },
  {
    id: "IDEA-03",
    requirement: "Search Functionality",
    scan: "search_feature_scan",
    collection: "search_feature_scan_collection",
    technicalTest: "Site search capability testing",
    passCriteria: "PASS: Functional search feature present",
    keyFields: ["search_present", "search_functionality", "search_effectiveness"]
  },
  {
    id: "IDEA-04",
    requirement: "Design System Compliance",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "USWDS component usage validation",
    passCriteria: "PASS: Consistent use of approved design system",
    keyFields: ["components_detected", "design_compliance", "uswds_version"]
  },
  {
    id: "IDEA-05",
    requirement: "Performance Standards",
    scan: "lighthouse_desktop_scan",
    collection: "lighthouse_desktop_scan_collection",
    technicalTest: "Page performance measurement",
    passCriteria: "PASS: Performance score ≥ 80",
    keyFields: ["performance_score", "load_time", "optimization_opportunities"]
  },
  {
    id: "IDEA-06",
    requirement: "Accessibility Requirements",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Same as Section 508/WCAG requirements",
    passCriteria: "PASS: Full accessibility compliance",
    keyFields: ["accessibility_score", "total_issues"]
  },
  {
    id: "IDEA-07",
    requirement: "Digital Analytics",
    scan: "dap, analytics",
    collection: "dap_scan_collection, analytics_scan_collection",
    technicalTest: "Government analytics implementation",
    passCriteria: "PASS: DAP properly implemented",
    keyFields: ["dap_detected", "analytics_compliance"]
  },
  {
    id: "IDEA-08",
    requirement: "HTTPS Implementation",
    scan: "pshtt",
    collection: "pshtt_scan_collection",
    technicalTest: "Same as OMB M-15-13 requirements",
    passCriteria: "PASS: Full HTTPS implementation",
    keyFields: ["Valid_HTTPS", "HSTS"]
  }
];

// USWDS (US Web Design System) Compliance - 6 requirements
export const USWDS_CONTROLS = [
  {
    id: "USWDS-01",
    requirement: "Component Library Usage",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "USWDS component detection and validation",
    passCriteria: "PASS: Approved components used correctly",
    keyFields: ["components_found", "component_usage", "implementation_quality"]
  },
  {
    id: "USWDS-02",
    requirement: "Typography Standards",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "Font family and sizing validation",
    passCriteria: "PASS: USWDS typography guidelines followed",
    keyFields: ["typography_compliance", "font_usage", "text_sizing"]
  },
  {
    id: "USWDS-03",
    requirement: "Color Palette Compliance",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "Color token usage validation",
    passCriteria: "PASS: Only approved USWDS colors used",
    keyFields: ["color_compliance", "color_tokens", "brand_colors"]
  },
  {
    id: "USWDS-04",
    requirement: "Grid System Implementation",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "Layout grid validation",
    passCriteria: "PASS: Proper USWDS grid system usage",
    keyFields: ["grid_compliance", "layout_structure"]
  },
  {
    id: "USWDS-05",
    requirement: "Icon Library Usage",
    scan: "uswds, uswds2",
    collection: "uswds_scan_collection, uswds2_scan_collection",
    technicalTest: "Icon implementation validation",
    passCriteria: "PASS: USWDS icon library used correctly",
    keyFields: ["icon_compliance", "icon_usage"]
  },
  {
    id: "USWDS-06",
    requirement: "Responsive Design Patterns",
    scan: "uswds, uswds2, lighthouse_scan",
    collection: "Multiple collections",
    technicalTest: "Responsive behavior validation",
    passCriteria: "PASS: USWDS responsive patterns implemented",
    keyFields: ["responsive_compliance", "mobile_patterns"]
  }
];

// NIST CSF - Identify Function (5 controls)
export const NIST_CSF_IDENTIFY_CONTROLS = [
  {
    id: "NIST-CSF-ID.AM-1",
    requirement: "ID.AM-1 - Physical devices and systems inventory",
    scan: "wappybird_scan, 200scanner",
    collection: "wappybird_scan_collection, 200scanner_scan_collection",
    technicalTest: "Technology stack and infrastructure detection",
    passCriteria: "PASS: Complete asset inventory maintained",
    keyFields: ["technologies_detected", "server_info", "infrastructure_components"]
  },
  {
    id: "NIST-CSF-ID.AM-2",
    requirement: "ID.AM-2 - Software platforms and applications inventory",
    scan: "wappybird_scan",
    collection: "wappybird_scan_collection",
    technicalTest: "Web technology and framework identification",
    passCriteria: "PASS: All software platforms documented",
    keyFields: ["technologies_detected", "versions", "frameworks", "cms_platforms"]
  },
  {
    id: "NIST-CSF-ID.AM-3",
    requirement: "ID.AM-3 - Organizational communication and data flows",
    scan: "outbound_link_scan, third_parties",
    collection: "outbound_link_scan_collection, third_parties_scan_collection",
    technicalTest: "External connection and data flow mapping",
    passCriteria: "PASS: Data flows documented and authorized",
    keyFields: ["external_domains", "third_party_services", "data_flows"]
  },
  {
    id: "NIST-CSF-ID.AM-4",
    requirement: "ID.AM-4 - External information systems",
    scan: "third_parties, outbound_link_scan",
    collection: "third_parties_scan_collection, outbound_link_scan_collection",
    technicalTest: "Third-party system identification",
    passCriteria: "PASS: All external systems cataloged",
    keyFields: ["detected_services", "external_integrations"]
  },
  {
    id: "NIST-CSF-ID.AM-5",
    requirement: "ID.AM-5 - Resources prioritized based on classification",
    scan: "nuclei_scan, zaproxy_scan",
    collection: "nuclei_scan_collection, zaproxy_scan_collection",
    technicalTest: "Asset criticality assessment via vulnerability impact",
    passCriteria: "PASS: Critical assets identified and prioritized",
    keyFields: ["risk_score", "asset_criticality", "vulnerability_impact"]
  }
];

// NIST CSF - Protect Function (10 controls)
export const NIST_CSF_PROTECT_CONTROLS = [
  {
    id: "NIST-CSF-PR.AC-1",
    requirement: "PR.AC-1 - Identities and credentials managed",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Authentication mechanism testing",
    passCriteria: "PASS: Secure authentication controls implemented",
    keyFields: ["authentication_bypass", "credential_management", "session_management"]
  },
  {
    id: "NIST-CSF-PR.AC-3",
    requirement: "PR.AC-3 - Remote access managed",
    scan: "pshtt, sslyze, nikto_scan",
    collection: "Multiple collections",
    technicalTest: "Remote access security validation",
    passCriteria: "PASS: Secure remote access controls",
    keyFields: ["https_enforcement", "vpn_detection", "remote_access_controls"]
  },
  {
    id: "NIST-CSF-PR.AC-4",
    requirement: "PR.AC-4 - Access permissions managed",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Authorization and privilege testing",
    passCriteria: "PASS: Least privilege access enforced",
    keyFields: ["access_control_alerts", "privilege_escalation", "authorization_bypass"]
  },
  {
    id: "NIST-CSF-PR.AC-5",
    requirement: "PR.AC-5 - Network integrity protected",
    scan: "pshtt, sslyze, csp",
    collection: "Multiple collections",
    technicalTest: "Network security controls validation",
    passCriteria: "PASS: Network security measures active",
    keyFields: ["https_enforcement", "security_headers", "network_security"]
  },
  {
    id: "NIST-CSF-PR.DS-1",
    requirement: "PR.DS-1 - Data-at-rest protected",
    scan: "nuclei_scan, nikto_scan",
    collection: "nuclei_scan_collection, nikto_scan_collection",
    technicalTest: "Data storage security assessment",
    passCriteria: "PASS: Data encryption and protection controls",
    keyFields: ["data_exposure", "sensitive_data_leakage"]
  },
  {
    id: "NIST-CSF-PR.DS-2",
    requirement: "PR.DS-2 - Data-in-transit protected",
    scan: "pshtt, sslyze",
    collection: "pshtt_scan_collection, sslyze_scan_collection",
    technicalTest: "Transmission encryption validation",
    passCriteria: "PASS: Strong encryption for all data transmission",
    keyFields: ["Valid_HTTPS", "cipher_suites", "protocol_security"]
  },
  {
    id: "NIST-CSF-PR.DS-3",
    requirement: "PR.DS-3 - Assets formally managed",
    scan: "wappybird_scan, outbound_link_scan",
    collection: "Multiple collections",
    technicalTest: "Asset management validation",
    passCriteria: "PASS: Formal asset management processes",
    keyFields: ["asset_inventory", "change_management"]
  },
  {
    id: "NIST-CSF-PR.IP-1",
    requirement: "PR.IP-1 - Baseline configuration established",
    scan: "nikto_scan, nuclei_scan",
    collection: "nikto_scan_collection, nuclei_scan_collection",
    technicalTest: "Security configuration assessment",
    passCriteria: "PASS: Secure baseline configurations implemented",
    keyFields: ["configuration_issues", "security_misconfigurations"]
  },
  {
    id: "NIST-CSF-PR.PT-1",
    requirement: "PR.PT-1 - Audit/log records determined",
    scan: "nikto_scan, zaproxy_scan",
    collection: "Multiple collections",
    technicalTest: "Logging and monitoring capability assessment",
    passCriteria: "PASS: Comprehensive logging implemented",
    keyFields: ["audit_capabilities", "log_management"]
  },
  {
    id: "NIST-CSF-PR.PT-3",
    requirement: "PR.PT-3 - Access to systems/assets controlled",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "Multiple collections",
    technicalTest: "Access control mechanism validation",
    passCriteria: "PASS: Robust access controls implemented",
    keyFields: ["access_control_alerts", "authentication_controls"]
  }
];

// NIST CSF - Detect Function (4 controls)
export const NIST_CSF_DETECT_CONTROLS = [
  {
    id: "NIST-CSF-DE.CM-1",
    requirement: "DE.CM-1 - Network monitored",
    scan: "outbound_link_scan, third_parties",
    collection: "outbound_link_scan_collection, third_parties_scan_collection",
    technicalTest: "Network traffic and connection monitoring",
    passCriteria: "PASS: Network monitoring capabilities active",
    keyFields: ["connection_monitoring", "traffic_analysis"]
  },
  {
    id: "NIST-CSF-DE.CM-7",
    requirement: "DE.CM-7 - Monitoring for unauthorized personnel/connections/devices/software",
    scan: "third_parties, wappybird_scan",
    collection: "Multiple collections",
    technicalTest: "Unauthorized component detection",
    passCriteria: "PASS: Unauthorized elements detected and flagged",
    keyFields: ["unauthorized_services", "rogue_components"]
  },
  {
    id: "NIST-CSF-DE.CM-8",
    requirement: "DE.CM-8 - Vulnerability scans performed",
    scan: "nuclei_scan, zaproxy_scan, wapiti_scan, nikto_scan",
    collection: "Multiple vulnerability collections",
    technicalTest: "Comprehensive vulnerability scanning",
    passCriteria: "PASS: Regular vulnerability assessments completed",
    keyFields: ["vulnerability_count", "scan_coverage", "remediation_status"]
  },
  {
    id: "NIST-CSF-DE.DP-3",
    requirement: "DE.DP-3 - Detection processes tested",
    scan: "All security scans",
    collection: "All security scan collections",
    technicalTest: "Detection capability validation",
    passCriteria: "PASS: Detection processes regularly tested",
    keyFields: ["detection_effectiveness", "test_results"]
  }
];

// NIST SP 800-53 - Access Control (AC) Family (7 controls)
export const NIST_800_53_AC_CONTROLS = [
  {
    id: "NIST-800-53-AC-2",
    requirement: "AC-2 - Account Management",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "User enumeration and account testing",
    passCriteria: "PASS: Secure account management practices",
    keyFields: ["user_enumeration", "account_lockout", "default_accounts"]
  },
  {
    id: "NIST-800-53-AC-3",
    requirement: "AC-3 - Access Enforcement",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Authorization bypass and privilege escalation testing",
    passCriteria: "PASS: Proper access controls enforced",
    keyFields: ["access_control_alerts", "authorization_bypass", "privilege_escalation"]
  },
  {
    id: "NIST-800-53-AC-6",
    requirement: "AC-6 - Least Privilege",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Privilege escalation and excessive permission testing",
    passCriteria: "PASS: Least privilege principles implemented",
    keyFields: ["privilege_escalation", "excessive_permissions"]
  },
  {
    id: "NIST-800-53-AC-7",
    requirement: "AC-7 - Unsuccessful Logon Attempts",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Brute force and account lockout testing",
    passCriteria: "PASS: Account lockout mechanisms active",
    keyFields: ["brute_force_protection", "account_lockout"]
  },
  {
    id: "NIST-800-53-AC-11",
    requirement: "AC-11 - Session Lock",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Session timeout and management testing",
    passCriteria: "PASS: Automatic session termination implemented",
    keyFields: ["session_management", "session_timeout"]
  },
  {
    id: "NIST-800-53-AC-12",
    requirement: "AC-12 - Session Termination",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Session invalidation testing",
    passCriteria: "PASS: Proper session termination controls",
    keyFields: ["session_management", "session_invalidation"]
  },
  {
    id: "NIST-800-53-AC-17",
    requirement: "AC-17 - Remote Access",
    scan: "pshtt, sslyze, outbound_link_scan",
    collection: "Multiple collections",
    technicalTest: "Remote access security validation",
    passCriteria: "PASS: Secure remote access implementations",
    keyFields: ["https_enforcement", "vpn_usage", "remote_connections"]
  }
];

// NIST SP 800-53 - System and Communications Protection (SC) Family (7 controls)
export const NIST_800_53_SC_CONTROLS = [
  {
    id: "NIST-800-53-SC-5",
    requirement: "SC-5 - Denial of Service Protection",
    scan: "200scanner, nuclei_scan",
    collection: "200scanner_scan_collection, nuclei_scan_collection",
    technicalTest: "Service availability and DoS resilience testing",
    passCriteria: "PASS: DoS protection mechanisms active",
    keyFields: ["availability_status", "dos_protection", "service_resilience"]
  },
  {
    id: "NIST-800-53-SC-7",
    requirement: "SC-7 - Boundary Protection",
    scan: "pshtt, sslyze, outbound_link_scan",
    collection: "Multiple collections",
    technicalTest: "Network boundary security validation",
    passCriteria: "PASS: Proper boundary protection controls",
    keyFields: ["firewall_detection", "boundary_controls", "network_segmentation"]
  },
  {
    id: "NIST-800-53-SC-8",
    requirement: "SC-8 - Transmission Confidentiality and Integrity",
    scan: "pshtt, sslyze",
    collection: "pshtt_scan_collection, sslyze_scan_collection",
    technicalTest: "Data transmission security validation",
    passCriteria: "PASS: All transmissions encrypted and integrity-protected",
    keyFields: ["Valid_HTTPS", "cipher_suites", "certificate_validation"]
  },
  {
    id: "NIST-800-53-SC-12",
    requirement: "SC-12 - Cryptographic Key Establishment and Management",
    scan: "sslyze",
    collection: "sslyze_scan_collection",
    technicalTest: "Cryptographic implementation assessment",
    passCriteria: "PASS: Strong key management practices",
    keyFields: ["key_exchange", "certificate_management", "cryptographic_algorithms"]
  },
  {
    id: "NIST-800-53-SC-13",
    requirement: "SC-13 - Cryptographic Protection",
    scan: "sslyze, pshtt",
    collection: "sslyze_scan_collection, pshtt_scan_collection",
    technicalTest: "Cryptographic strength validation",
    passCriteria: "PASS: FIPS 140-2 approved algorithms used",
    keyFields: ["cipher_suites", "cryptographic_strength", "approved_algorithms"]
  },
  {
    id: "NIST-800-53-SC-15",
    requirement: "SC-15 - Collaborative Computing Devices",
    scan: "third_parties, outbound_link_scan",
    collection: "third_parties_scan_collection, outbound_link_scan_collection",
    technicalTest: "Third-party collaboration service detection",
    passCriteria: "PASS: Authorized collaboration tools only",
    keyFields: ["collaboration_services", "third_party_communications"]
  },
  {
    id: "NIST-800-53-SC-23",
    requirement: "SC-23 - Session Authenticity",
    scan: "zaproxy_scan, sslyze",
    collection: "zaproxy_scan_collection, sslyze_scan_collection",
    technicalTest: "Session protection and authenticity validation",
    passCriteria: "PASS: Session authenticity mechanisms implemented",
    keyFields: ["session_protection", "certificate_validation", "session_hijacking_prevention"]
  }
];

// NIST SP 800-53 - System and Information Integrity (SI) Family (7 controls)
export const NIST_800_53_SI_CONTROLS = [
  {
    id: "NIST-800-53-SI-2",
    requirement: "SI-2 - Flaw Remediation",
    scan: "nuclei_scan, zaproxy_scan, wapiti_scan, nikto_scan",
    collection: "Multiple vulnerability collections",
    technicalTest: "Known vulnerability detection and patch validation",
    passCriteria: "PASS: All critical/high vulnerabilities patched",
    keyFields: ["cve_findings", "vulnerability_age", "patch_status"]
  },
  {
    id: "NIST-800-53-SI-3",
    requirement: "SI-3 - Malicious Code Protection",
    scan: "nuclei_scan, nikto_scan",
    collection: "nuclei_scan_collection, nikto_scan_collection",
    technicalTest: "Malware and malicious code detection",
    passCriteria: "PASS: No malicious code detected",
    keyFields: ["malware_detection", "suspicious_files"]
  },
  {
    id: "NIST-800-53-SI-4",
    requirement: "SI-4 - Information System Monitoring",
    scan: "zaproxy_scan, nuclei_scan, third_parties",
    collection: "Multiple collections",
    technicalTest: "Security monitoring capability assessment",
    passCriteria: "PASS: Comprehensive monitoring implemented",
    keyFields: ["monitoring_capabilities", "intrusion_detection"]
  },
  {
    id: "NIST-800-53-SI-7",
    requirement: "SI-7 - Software, Firmware, and Information Integrity",
    scan: "nuclei_scan, wappybird_scan",
    collection: "nuclei_scan_collection, wappybird_scan_collection",
    technicalTest: "Software integrity validation",
    passCriteria: "PASS: Integrity checking mechanisms active",
    keyFields: ["integrity_checks", "software_validation"]
  },
  {
    id: "NIST-800-53-SI-10",
    requirement: "SI-10 - Information Input Validation",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Input validation testing across all input vectors",
    passCriteria: "PASS: Comprehensive input validation implemented",
    keyFields: ["input_validation_issues", "injection_vulnerabilities"]
  },
  {
    id: "NIST-800-53-SI-11",
    requirement: "SI-11 - Error Handling",
    scan: "nikto_scan, zaproxy_scan",
    collection: "nikto_scan_collection, zaproxy_scan_collection",
    technicalTest: "Error message and exception handling testing",
    passCriteria: "PASS: Secure error handling implemented",
    keyFields: ["error_disclosure", "information_leakage"]
  },
  {
    id: "NIST-800-53-SI-16",
    requirement: "SI-16 - Memory Protection",
    scan: "nuclei_scan, wapiti_scan",
    collection: "nuclei_scan_collection, wapiti_scan_collection",
    technicalTest: "Memory corruption vulnerability testing",
    passCriteria: "PASS: Memory protection mechanisms active",
    keyFields: ["buffer_overflow", "memory_corruption"]
  }
];

// NIST SP 800-53 - Configuration Management (CM) Family (4 controls)
export const NIST_800_53_CM_CONTROLS = [
  {
    id: "NIST-800-53-CM-2",
    requirement: "CM-2 - Baseline Configuration",
    scan: "nikto_scan, nuclei_scan, wappybird_scan",
    collection: "Multiple collections",
    technicalTest: "Security configuration baseline validation",
    passCriteria: "PASS: Secure baseline configurations maintained",
    keyFields: ["configuration_issues", "baseline_deviations"]
  },
  {
    id: "NIST-800-53-CM-6",
    requirement: "CM-6 - Configuration Settings",
    scan: "nikto_scan, nuclei_scan, csp",
    collection: "Multiple collections",
    technicalTest: "Security configuration validation",
    passCriteria: "PASS: Secure configuration settings implemented",
    keyFields: ["security_misconfigurations", "hardening_status"]
  },
  {
    id: "NIST-800-53-CM-7",
    requirement: "CM-7 - Least Functionality",
    scan: "wappybird_scan, nikto_scan",
    collection: "wappybird_scan_collection, nikto_scan_collection",
    technicalTest: "Unnecessary service and functionality detection",
    passCriteria: "PASS: Only necessary services and functions enabled",
    keyFields: ["unnecessary_services", "attack_surface"]
  },
  {
    id: "NIST-800-53-CM-8",
    requirement: "CM-8 - Information System Component Inventory",
    scan: "wappybird_scan, third_parties",
    collection: "wappybird_scan_collection, third_parties_scan_collection",
    technicalTest: "Component and service inventory validation",
    passCriteria: "PASS: Complete and accurate component inventory",
    keyFields: ["component_inventory", "service_catalog"]
  }
];

// NIST SP 800-53 - Identification and Authentication (IA) Family (4 controls)
export const NIST_800_53_IA_CONTROLS = [
  {
    id: "NIST-800-53-IA-2",
    requirement: "IA-2 - Identification and Authentication",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Authentication mechanism testing",
    passCriteria: "PASS: Strong authentication controls implemented",
    keyFields: ["authentication_bypass", "weak_authentication"]
  },
  {
    id: "NIST-800-53-IA-5",
    requirement: "IA-5 - Authenticator Management",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "zaproxy_scan_collection, wapiti_scan_collection",
    technicalTest: "Password and credential policy testing",
    passCriteria: "PASS: Secure authenticator management practices",
    keyFields: ["weak_passwords", "credential_management"]
  },
  {
    id: "NIST-800-53-IA-6",
    requirement: "IA-6 - Authenticator Feedback",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Authentication feedback testing",
    passCriteria: "PASS: Secure authentication feedback mechanisms",
    keyFields: ["authentication_feedback", "information_disclosure"]
  },
  {
    id: "NIST-800-53-IA-7",
    requirement: "IA-7 - Cryptographic Module Authentication",
    scan: "sslyze",
    collection: "sslyze_scan_collection",
    technicalTest: "Cryptographic authentication validation",
    passCriteria: "PASS: Strong cryptographic authentication",
    keyFields: ["certificate_authentication", "cryptographic_validation"]
  }
];

// FISMA (Federal Information Security Management Act) - 8 requirements
export const FISMA_CONTROLS = [
  {
    id: "FISMA-01",
    requirement: "Vulnerability Assessment",
    scan: "nuclei_scan, zaproxy_scan, wapiti_scan, nikto_scan",
    collection: "Multiple vulnerability collections",
    technicalTest: "Comprehensive vulnerability identification and assessment",
    passCriteria: "PASS: Vulnerability assessment completed, critical vulnerabilities remediated within SLA",
    keyFields: ["vulnerability_count", "severity_distribution", "remediation_status"]
  },
  {
    id: "FISMA-02",
    requirement: "Configuration Management",
    scan: "nikto_scan, nuclei_scan, csp",
    collection: "Multiple collections",
    technicalTest: "Security configuration validation and compliance",
    passCriteria: "PASS: Secure configurations implemented and maintained",
    keyFields: ["configuration_compliance", "security_hardening"]
  },
  {
    id: "FISMA-03",
    requirement: "Incident Response Capability",
    scan: "zaproxy_scan, nuclei_scan, third_parties",
    collection: "Multiple collections",
    technicalTest: "Security incident detection and response capability",
    passCriteria: "PASS: Incident detection and response mechanisms active",
    keyFields: ["security_alerts", "incident_indicators", "response_capabilities"]
  },
  {
    id: "FISMA-04",
    requirement: "Continuous Monitoring",
    scan: "All security scans",
    collection: "All security collections",
    technicalTest: "Ongoing security assessment and monitoring",
    passCriteria: "PASS: Continuous security monitoring implemented",
    keyFields: ["scan_frequency", "monitoring_coverage", "security_posture_trends"]
  },
  {
    id: "FISMA-05",
    requirement: "Risk Assessment",
    scan: "nuclei_scan, zaproxy_scan, wapiti_scan",
    collection: "Multiple vulnerability collections",
    technicalTest: "Risk identification, analysis, and mitigation",
    passCriteria: "PASS: Comprehensive risk assessment completed and maintained",
    keyFields: ["risk_scores", "threat_landscape", "mitigation_status"]
  },
  {
    id: "FISMA-06",
    requirement: "Security Awareness and Training",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "Multiple collections",
    technicalTest: "Human factor security testing (social engineering indicators)",
    passCriteria: "PASS: Security awareness indicators positive",
    keyFields: ["social_engineering_vulnerabilities", "human_factor_risks"]
  },
  {
    id: "FISMA-07",
    requirement: "System and Services Acquisition",
    scan: "third_parties, wappybird_scan",
    collection: "third_parties_scan_collection, wappybird_scan_collection",
    technicalTest: "Third-party service and technology assessment",
    passCriteria: "PASS: All acquisitions properly vetted for security",
    keyFields: ["third_party_risk_assessment", "supply_chain_security"]
  },
  {
    id: "FISMA-08",
    requirement: "Media Protection",
    scan: "nuclei_scan, nikto_scan",
    collection: "Multiple collections",
    technicalTest: "Data storage and media security assessment",
    passCriteria: "PASS: Media protection controls implemented",
    keyFields: ["data_leakage", "storage_security"]
  }
];

// Digital Government Strategy - 7 requirements
export const DIGITAL_GOVERNMENT_STRATEGY_CONTROLS = [
  {
    id: "DGS-01",
    requirement: "Mobile-First Design",
    scan: "lighthouse_scan",
    collection: "lighthouse_scan_collection",
    technicalTest: "Mobile performance, usability, and responsiveness testing",
    passCriteria: "PASS: Mobile score ≥ 90, mobile-first design patterns",
    keyFields: ["mobile_score", "mobile_usability", "responsive_design", "mobile_performance"]
  },
  {
    id: "DGS-02",
    requirement: "Performance Optimization",
    scan: "lighthouse_desktop_scan, lighthouse_scan",
    collection: "Multiple lighthouse collections",
    technicalTest: "Page load performance and optimization assessment",
    passCriteria: "PASS: Performance score ≥ 80, load time < 3 seconds",
    keyFields: ["performance_score", "load_time", "first_contentful_paint", "largest_contentful_paint"]
  },
  {
    id: "DGS-03",
    requirement: "Search Engine Optimization",
    scan: "seo, sitemap, pagedata",
    collection: "seo_scan_collection, sitemap_scan_collection, pagedata_scan_collection",
    technicalTest: "SEO best practices and content discoverability",
    passCriteria: "PASS: SEO score ≥ 90, proper metadata implementation",
    keyFields: ["seo_score", "meta_tags", "structured_data", "sitemap_validity"]
  },
  {
    id: "DGS-04",
    requirement: "Digital Analytics Implementation",
    scan: "analytics, dap, gov_analytics",
    collection: "Multiple analytics collections",
    technicalTest: "Government analytics tracking and compliance",
    passCriteria: "PASS: DAP implemented correctly, privacy-compliant tracking",
    keyFields: ["dap_detected", "analytics_implementation", "privacy_compliance"]
  },
  {
    id: "DGS-05",
    requirement: "Content Management",
    scan: "seo, pagedata",
    collection: "seo_scan_collection, pagedata_scan_collection",
    technicalTest: "Content quality and management assessment",
    passCriteria: "PASS: High-quality, well-structured content",
    keyFields: ["content_quality", "page_structure", "content_freshness"]
  },
  {
    id: "DGS-06",
    requirement: "Customer Experience",
    scan: "lighthouse_scan, a11y, search_feature_scan",
    collection: "Multiple collections",
    technicalTest: "User experience and satisfaction measurement",
    passCriteria: "PASS: Excellent user experience metrics",
    keyFields: ["user_experience_score", "accessibility_compliance", "search_effectiveness"]
  },
  {
    id: "DGS-07",
    requirement: "Digital Service Delivery",
    scan: "200scanner, lighthouse_scan",
    collection: "Multiple collections",
    technicalTest: "Service availability and delivery performance",
    passCriteria: "PASS: 99.9% uptime, fast service delivery",
    keyFields: ["availability_metrics", "service_performance", "delivery_speed"]
  }
];

// OMB A-130 (Managing Information as a Strategic Resource) - 7 requirements
export const OMB_A_130_CONTROLS = [
  {
    id: "OMB-A-130-01",
    requirement: "Privacy Impact Assessment",
    scan: "privacy, third_parties",
    collection: "privacy_scan_collection, third_parties_scan_collection",
    technicalTest: "Privacy policy and data collection assessment",
    passCriteria: "PASS: Privacy policy present, minimal data collection documented",
    keyFields: ["privacy_policy_present", "data_collection_practices", "pii_handling"]
  },
  {
    id: "OMB-A-130-02",
    requirement: "Information Lifecycle Management",
    scan: "analytics, third_parties, dap",
    collection: "Multiple collections",
    technicalTest: "Data retention and sharing policy compliance",
    passCriteria: "PASS: Data lifecycle policies implemented and followed",
    keyFields: ["data_retention_policies", "information_sharing", "data_governance"]
  },
  {
    id: "OMB-A-130-03",
    requirement: "Information Security Program",
    scan: "All security scans",
    collection: "All security collections",
    technicalTest: "Security program implementation validation",
    passCriteria: "PASS: Comprehensive security program active",
    keyFields: ["security_controls", "program_effectiveness"]
  },
  {
    id: "OMB-A-130-04",
    requirement: "Information System Boundaries",
    scan: "outbound_link_scan, third_parties",
    collection: "Multiple collections",
    technicalTest: "System boundary definition and control",
    passCriteria: "PASS: Clear system boundaries with appropriate controls",
    keyFields: ["system_boundaries", "boundary_protection"]
  },
  {
    id: "OMB-A-130-05",
    requirement: "Federal Enterprise Architecture",
    scan: "wappybird_scan, uswds",
    collection: "Multiple collections",
    technicalTest: "Architecture compliance and standards adherence",
    passCriteria: "PASS: Architecture standards followed",
    keyFields: ["architecture_compliance", "standards_adherence"]
  },
  {
    id: "OMB-A-130-06",
    requirement: "Information Sharing",
    scan: "third_parties, outbound_link_scan",
    collection: "Multiple collections",
    technicalTest: "Information sharing agreement compliance",
    passCriteria: "PASS: All information sharing authorized and controlled",
    keyFields: ["information_sharing_agreements", "data_sharing_controls"]
  },
  {
    id: "OMB-A-130-07",
    requirement: "Records Management",
    scan: "analytics, privacy",
    collection: "Multiple collections",
    technicalTest: "Electronic records management compliance",
    passCriteria: "PASS: Proper records management practices",
    keyFields: ["records_retention", "information_management"]
  }
];

// OMB M-17-06 (Policies for Federal Agency Public Websites and Digital Services) - 9 requirements
export const OMB_M_17_06_CONTROLS = [
  {
    id: "OMB-M-17-06-01",
    requirement: "Accessibility Standards",
    scan: "a11y, lighthouse_scan",
    collection: "a11y_scan_collection, lighthouse_scan_collection",
    technicalTest: "Section 508 and WCAG 2.1 AA compliance testing",
    passCriteria: "PASS: Full accessibility compliance achieved",
    keyFields: ["accessibility_score", "violation_count", "compliance_status"]
  },
  {
    id: "OMB-M-17-06-02",
    requirement: "Mobile-Friendly Requirements",
    scan: "lighthouse_scan",
    collection: "lighthouse_scan_collection",
    technicalTest: "Mobile responsiveness and performance validation",
    passCriteria: "PASS: Mobile-first design implementation verified",
    keyFields: ["mobile_score", "responsive_design", "mobile_performance"]
  },
  {
    id: "OMB-M-17-06-03",
    requirement: "Search Engine Optimization",
    scan: "seo, sitemap",
    collection: "seo_scan_collection, sitemap_scan_collection",
    technicalTest: "SEO implementation and search visibility",
    passCriteria: "PASS: Excellent search engine visibility",
    keyFields: ["seo_score", "search_visibility", "metadata_quality"]
  },
  {
    id: "OMB-M-17-06-04",
    requirement: "Digital Analytics",
    scan: "dap, analytics",
    collection: "dap_scan_collection, analytics_scan_collection",
    technicalTest: "DAP implementation and analytics compliance",
    passCriteria: "PASS: Proper analytics implementation",
    keyFields: ["dap_compliance", "analytics_accuracy"]
  },
  {
    id: "OMB-M-17-06-05",
    requirement: "Customer Experience",
    scan: "lighthouse_scan, search_feature_scan",
    collection: "Multiple collections",
    technicalTest: "User experience and service quality measurement",
    passCriteria: "PASS: Superior customer experience metrics",
    keyFields: ["user_experience_metrics", "service_quality"]
  },
  {
    id: "OMB-M-17-06-06",
    requirement: "Content and Information Architecture",
    scan: "seo, pagedata, search_feature_scan",
    collection: "Multiple collections",
    technicalTest: "Content organization and findability assessment",
    passCriteria: "PASS: Well-organized, findable content",
    keyFields: ["content_architecture", "information_findability"]
  },
  {
    id: "OMB-M-17-06-07",
    requirement: "Multilingual Content",
    scan: "a11y",
    collection: "a11y_scan_collection",
    technicalTest: "Language identification and multilingual support",
    passCriteria: "PASS: Proper language support where required",
    keyFields: ["language_support", "multilingual_compliance"]
  },
  {
    id: "OMB-M-17-06-08",
    requirement: "Third-Party Services",
    scan: "third_parties, privacy",
    collection: "Multiple collections",
    technicalTest: "Third-party service usage and privacy compliance",
    passCriteria: "PASS: Minimal, authorized third-party services",
    keyFields: ["third_party_compliance", "privacy_protection"]
  },
  {
    id: "OMB-M-17-06-09",
    requirement: "Domain and Hosting",
    scan: "pshtt, trustymail",
    collection: "Multiple collections",
    technicalTest: "Domain security and hosting compliance",
    passCriteria: "PASS: Secure, compliant hosting arrangements",
    keyFields: ["domain_security", "hosting_compliance"]
  }
];

// Additional Digital Service Standards - 4 standards
export const DIGITAL_SERVICE_STANDARDS = [
  {
    id: "DSS-01",
    requirement: "API Standards - API endpoint security and functionality",
    scan: "nuclei_scan, zaproxy_scan",
    collection: "Multiple collections",
    technicalTest: "API security and functionality testing",
    passCriteria: "PASS: Secure, well-documented APIs",
    keyFields: ["api_security", "api_documentation"]
  },
  {
    id: "DSS-02",
    requirement: "Content Strategy - Content quality and effectiveness",
    scan: "seo, pagedata",
    collection: "Multiple collections",
    technicalTest: "Content analysis and optimization",
    passCriteria: "PASS: High-quality, user-focused content",
    keyFields: ["content_quality", "user_engagement"]
  },
  {
    id: "DSS-03",
    requirement: "Performance Budgets - Resource optimization and loading performance",
    scan: "lighthouse_desktop_scan, lighthouse_scan",
    collection: "Multiple collections",
    technicalTest: "Performance budget compliance",
    passCriteria: "PASS: Performance budgets met",
    keyFields: ["resource_usage", "performance_metrics"]
  },
  {
    id: "DSS-04",
    requirement: "Progressive Enhancement - Baseline functionality and enhancement layers",
    scan: "lighthouse_scan, a11y",
    collection: "Multiple collections",
    technicalTest: "Progressive enhancement validation",
    passCriteria: "PASS: Core functionality without JavaScript",
    keyFields: ["progressive_enhancement", "baseline_functionality"]
  }
];

// CMMC (Cybersecurity Maturity Model Certification) - 5 controls (placeholder)
export const CMMC_CONTROLS = [
  {
    id: "CMMC-01",
    requirement: "Access Control",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "Multiple collections",
    technicalTest: "Access control and authentication testing",
    passCriteria: "PASS: Strong access controls implemented",
    keyFields: ["access_control", "authentication"]
  },
  {
    id: "CMMC-02",
    requirement: "Identification and Authentication",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Identity and authentication validation",
    passCriteria: "PASS: Secure authentication mechanisms",
    keyFields: ["authentication_mechanisms", "identity_management"]
  },
  {
    id: "CMMC-03",
    requirement: "Media Protection",
    scan: "zaproxy_scan, wapiti_scan",
    collection: "Multiple collections",
    technicalTest: "Data and media protection assessment",
    passCriteria: "PASS: Sensitive data protected",
    keyFields: ["data_protection", "media_sanitization"]
  },
  {
    id: "CMMC-04",
    requirement: "Physical Protection",
    scan: "wappybird_scan",
    collection: "wappybird_scan_collection",
    technicalTest: "Infrastructure physical security assessment",
    passCriteria: "PASS: Secure physical infrastructure",
    keyFields: ["infrastructure_security", "hosting_environment"]
  },
  {
    id: "CMMC-05",
    requirement: "System and Communications Protection",
    scan: "pshtt, sslyze",
    collection: "Multiple collections",
    technicalTest: "Communication security and encryption",
    passCriteria: "PASS: Secure communications channels",
    keyFields: ["encryption_standards", "communication_security"]
  }
];

// TIC 2.0 (Trusted Internet Connections) - 5 controls (placeholder)
export const TIC_2_0_CONTROLS = [
  {
    id: "TIC-2.0-01",
    requirement: "Boundary Protection",
    scan: "outbound_link_scan",
    collection: "outbound_link_scan_collection",
    technicalTest: "Network boundary and external connection assessment",
    passCriteria: "PASS: Secure network boundaries",
    keyFields: ["boundary_security", "external_connections"]
  },
  {
    id: "TIC-2.0-02",
    requirement: "Intrusion Detection",
    scan: "zaproxy_scan",
    collection: "zaproxy_scan_collection",
    technicalTest: "Detection capability assessment",
    passCriteria: "PASS: Intrusion detection mechanisms present",
    keyFields: ["detection_capabilities", "security_monitoring"]
  },
  {
    id: "TIC-2.0-03",
    requirement: "Incident Response",
    scan: "wappybird_scan",
    collection: "wappybird_scan_collection",
    technicalTest: "Incident response readiness assessment",
    passCriteria: "PASS: Incident response capabilities documented",
    keyFields: ["incident_response", "readiness"]
  },
  {
    id: "TIC-2.0-04",
    requirement: "Secure Configurations",
    scan: "nikto_scan, wapiti_scan",
    collection: "Multiple collections",
    technicalTest: "System configuration security testing",
    passCriteria: "PASS: Systems securely configured",
    keyFields: ["system_configuration", "security_baselines"]
  },
  {
    id: "TIC-2.0-05",
    requirement: "DNS Sinkholing",
    scan: "trustymail",
    collection: "trustymail_scan_collection",
    technicalTest: "DNS security and sinkholing capability",
    passCriteria: "PASS: Secure DNS and sinkholing active",
    keyFields: ["dns_security", "threat_intelligence"]
  }
];

// Consolidated exports for easy access
export const ALL_FRAMEWORKS = {
  OMB_M_15_13: {
    name: "OMB M-15-13 (HTTPS-Only Standard)",
    controls: OMB_M_15_13_CONTROLS,
    count: OMB_M_15_13_CONTROLS.length
  },
  BOD_18_01: {
    name: "BOD 18-01 (Enhance Email and Web Security)",
    controls: BOD_18_01_CONTROLS,
    count: BOD_18_01_CONTROLS.length
  },
  WEB_APP_SECURITY: {
    name: "Web Application Security Configuration",
    controls: WEB_APP_SECURITY_CONTROLS,
    count: WEB_APP_SECURITY_CONTROLS.length
  },
  TIC_3_0: {
    name: "TIC 3.0 (Trusted Internet Connections)",
    controls: TIC_3_0_CONTROLS,
    count: TIC_3_0_CONTROLS.length
  },
  SECTION_508: {
    name: "Section 508 Compliance",
    controls: SECTION_508_CONTROLS,
    count: SECTION_508_CONTROLS.length
  },
  WCAG_2_1_AA: {
    name: "WCAG 2.1 AA Compliance",
    controls: WCAG_2_1_AA_CONTROLS,
    count: WCAG_2_1_AA_CONTROLS.length
  },
  CENTURY_21_IDEA: {
    name: "21st Century IDEA Act",
    controls: CENTURY_21_IDEA_CONTROLS,
    count: CENTURY_21_IDEA_CONTROLS.length
  },
  USWDS: {
    name: "USWDS (US Web Design System) Compliance",
    controls: USWDS_CONTROLS,
    count: USWDS_CONTROLS.length
  },
  NIST_CSF_IDENTIFY: {
    name: "NIST CSF - Identify Function",
    controls: NIST_CSF_IDENTIFY_CONTROLS,
    count: NIST_CSF_IDENTIFY_CONTROLS.length
  },
  NIST_CSF_PROTECT: {
    name: "NIST CSF - Protect Function",
    controls: NIST_CSF_PROTECT_CONTROLS,
    count: NIST_CSF_PROTECT_CONTROLS.length
  },
  NIST_CSF_DETECT: {
    name: "NIST CSF - Detect Function",
    controls: NIST_CSF_DETECT_CONTROLS,
    count: NIST_CSF_DETECT_CONTROLS.length
  },
  NIST_800_53_AC: {
    name: "NIST SP 800-53 - Access Control (AC) Family",
    controls: NIST_800_53_AC_CONTROLS,
    count: NIST_800_53_AC_CONTROLS.length
  },
  NIST_800_53_SC: {
    name: "NIST SP 800-53 - System and Communications Protection (SC) Family",
    controls: NIST_800_53_SC_CONTROLS,
    count: NIST_800_53_SC_CONTROLS.length
  },
  NIST_800_53_SI: {
    name: "NIST SP 800-53 - System and Information Integrity (SI) Family",
    controls: NIST_800_53_SI_CONTROLS,
    count: NIST_800_53_SI_CONTROLS.length
  },
  NIST_800_53_CM: {
    name: "NIST SP 800-53 - Configuration Management (CM) Family",
    controls: NIST_800_53_CM_CONTROLS,
    count: NIST_800_53_CM_CONTROLS.length
  },
  NIST_800_53_IA: {
    name: "NIST SP 800-53 - Identification and Authentication (IA) Family",
    controls: NIST_800_53_IA_CONTROLS,
    count: NIST_800_53_IA_CONTROLS.length
  },
  FISMA: {
    name: "FISMA (Federal Information Security Management Act)",
    controls: FISMA_CONTROLS,
    count: FISMA_CONTROLS.length
  },
  DIGITAL_GOVERNMENT_STRATEGY: {
    name: "Digital Government Strategy",
    controls: DIGITAL_GOVERNMENT_STRATEGY_CONTROLS,
    count: DIGITAL_GOVERNMENT_STRATEGY_CONTROLS.length
  },
  OMB_A_130: {
    name: "OMB A-130 (Managing Information as a Strategic Resource)",
    controls: OMB_A_130_CONTROLS,
    count: OMB_A_130_CONTROLS.length
  },
  OMB_M_17_06: {
    name: "OMB M-17-06 (Policies for Federal Agency Public Websites and Digital Services)",
    controls: OMB_M_17_06_CONTROLS,
    count: OMB_M_17_06_CONTROLS.length
  },
  DIGITAL_SERVICE_STANDARDS: {
    name: "Additional Digital Service Standards",
    controls: DIGITAL_SERVICE_STANDARDS,
    count: DIGITAL_SERVICE_STANDARDS.length
  },
  CMMC: {
    name: "CMMC (Cybersecurity Maturity Model Certification)",
    controls: CMMC_CONTROLS,
    count: CMMC_CONTROLS.length
  },
  TIC_2_0: {
    name: "TIC 2.0 (Trusted Internet Connections)",
    controls: TIC_2_0_CONTROLS,
    count: TIC_2_0_CONTROLS.length
  }
};

// Calculate total controls across all frameworks
export const TOTAL_CONTROLS = "200+";

// Export framework summary
export const FRAMEWORK_SUMMARY = {
  totalFrameworks: 18,
  totalControls: TOTAL_CONTROLS,
  frameworks: Object.entries(ALL_FRAMEWORKS).map(([key, value]) => ({
    key,
    name: value.name,
    controlCount: value.count
  }))
};

// Platform Architecture Context
export const PLATFORM_ARCHITECTURE = {
  scanningEngine: "Python orchestrator running 25+ specialized tools",
  dataStorage: "MongoDB with dedicated collections per scan type",
  realTimeTracking: "Status updates via fact_SCAN_RECORDS_Collection",
  outputGeneration: "CSV/JSON reports in output/[DOMAIN]/ directory structure"
};

// Framework Categories for filtering and organization
export const FRAMEWORK_CATEGORIES = {
  webSecurity: {
    name: "Web Security & Infrastructure",
    description: "HTTPS enforcement, email security, web application protection, and network security",
    frameworks: ["OMB M-15-13", "BOD 18-01", "Web Application Security", "TIC 3.0"]
  },
  accessibility: {
    name: "Accessibility & User Experience",
    description: "Digital accessibility, design standards, and user experience requirements",
    frameworks: ["Section 508", "WCAG 2.1 AA", "21st Century IDEA", "USWDS"]
  },
  riskSecurity: {
    name: "Risk & Security Management",
    description: "Cybersecurity frameworks, security controls, and risk management",
    frameworks: ["NIST CSF", "NIST SP 800-53", "FISMA", "CMMC"]
  },
  digitalGovernment: {
    name: "Digital Government & Performance",
    description: "Digital service standards, information management, and performance optimization",
    frameworks: ["Digital Government Strategy", "OMB A-130", "OMB M-17-06", "TIC 2.0"]
  }
};